
import { SET_FACULTY } from '../actionTypes'

import isEmpty from '../validation/is-empty'

const initialState = {
    isAuthenticated: false,
    faculty: {},
    flag: false,
    updateProfileFlag: false,
    facultyAddSubjectFlag: false,
    allSubjectCodeList: [],
    allStudentMarkList: [],
    allAssignmentList: [],
    allStudent: [],
    allSubject: {},
    allSubject: [],
    studentMarkList:[],
    subjectFacultyList:[],
    fetchedStudents: [],
    fetchedStudentsMarks: [],
    fetchedStudentsAttendence:[],
    fetchedDailyReport:[],
    timetableData: [],
    fetchedStudentsHelper: true,
    fetchStudentsMarkHelper: true
}


const facultyReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_ALL_TIMETABLE":
            return {
                ...state,
                timetableData: action.payload,
            }
        case SET_FACULTY: {
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                faculty: action.payload
            }
        }
        case "FACULTY_ADD_SUBJECT_FLAG":
            return {
                ...state,
                facultyAddSubjectFlag: action.payload
            };
        case "GET_SUBJECTS":
            const sortedSubject = action.payload.slice().sort((a, b) => {
                const yearOrder = { I: 1, II: 2, III: 3, IV: 4, PassedOut: 5 };
                const yearA = yearOrder[a.year] || Infinity;
                const yearB = yearOrder[b.year] || Infinity;
                if (yearA === yearB) {
                    return a.semester.localeCompare(b.semester);
                }
        
                return yearA - yearB;
            });
            return {
                ...state,
                allSubject: sortedSubject
            };
        case "GET_ALL_STUDENT": {
            const sortedStudents = action.payload.slice().sort((a, b) => {
                const yearOrder = { I: 1, II: 2, III: 3, IV: 4, PassedOut: 5 };
        
                const yearA = yearOrder[a.year] || Infinity;
                const yearB = yearOrder[b.year] || Infinity;
        
                // If the years are the same, then sort by registrationNumber
                if (yearA === yearB) {
                    return a.registrationNumber.localeCompare(b.registrationNumber);
                }
        
                return yearA - yearB;
            });
        
            return {
                ...state,
                allStudent: sortedStudents
            };
        }
        
        case "FETCH_STUDENTS": {
            const sortedStudents = action.payload.slice().sort((a, b) =>
                a.registrationNumber.localeCompare(b.registrationNumber)
            );

            return {
                ...state,
                fetchedStudentsHelper: false,
                fetchedStudents: sortedStudents
            };
        }

        case "GET_DAILY_REPORT": {
            return {
                ...state,
                fetchedDailyReport: action.payload
            }
        }
        case "GET_ALL_STUDENT_ATTENDENCE": {
            return {
                ...state,
                fetchedStudentsAttendence: action.payload
            }
        }
        case "FETCH_STUDENTS_MARK": {
            return {
                ...state,
                fetchStudentsMarkHelper: false,
                fetchedStudentsMarks: action.payload
            }
        }
        case "FACULTY_UPDATE_PROFILE_FLAG": {
            return {
                ...state,
                updateProfileFlag: action.payload
            }
        }
        case "GET_SUBJECTCODE_LIST": {
            return {
                ...state,
                allSubjectCodeList: action.payload
            }
        }
        case "GET_STUDENTMARKS_LIST": {
            return {
                ...state,
                allStudentMarkList: action.payload
            }
        }
        case "GET_SUBJECTFACULTY_LIST": {
            return {
                ...state,
                subjectFacultyList: action.payload
            }
        }
        case "GET_ASSIGNMENTS_LIST": {
            return {
                ...state,
                allAssignmentList: action.payload
            }
        }
        case "GET_STUDENTMARKS": {
            const sortedStudents = action.payload.result.slice().sort((a, b) =>
                a.registrationNumber.localeCompare(b.registrationNumber)
            );
        
            return {
                ...state,
                studentMarks: false,
                studentMarkList: {
                    result: sortedStudents,
                    studentMark: action.payload.studentMark
                }
            };
        }
        
        case "HELPER": {
            return {
                ...state,
                fetchedStudentsHelper: action.payload
            }
        }
        default:
            return state
    }
}

export default facultyReducer